import React, {Component} from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList, Cell,
} from 'recharts';
import {colors} from '../../../../common/constants/colors';

class BarChartInCpd extends Component {
  changeBarColor() {
    const {data} = this.props;
    return data.map((entry, index) => (
      <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
    ));
  }

  render() {
    const {data, handleDrillDownByUser} = this.props;
    return (
      <ResponsiveContainer width='100%' height={500}>
        <BarChart
          data={data}
          margin={{'top': 15, 'right': 25, 'left': 0, 'bottom': 5}}
        >
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey='label' />
          <YAxis />

          <Tooltip />
          <Legend />
          <Bar
            dataKey='value'
            fill='#FFF'
            name='Total Líneas'
            onClick={({label}) => handleDrillDownByUser(label)}
          >
            {this.changeBarColor()}
            <LabelList dataKey='value' position='top' />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default BarChartInCpd;
